<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="reservedInstanceList"
      style="width: 100.1%;"
      :max-height="tableHeight"
      :loading="modalLoading"
    >
      <template slot-scope="{ row, index }" slot="operation">
        <Button
          type="info"
          size="small"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:reservedInstanceResource:ec2:config'
          ]"
          @click="configTag(row)"
          >{{ $t('RAM.AWS.reservedInstanceTag.configTag') }}</Button
        >
      </template>
    </Table>
    <!-- 配置标签页面 -->
    <configuration-reserved-instance-tag
      v-if="isShowReservedInstanceTag"
      ref="configurationReservedInstanceTag"
    ></configuration-reserved-instance-tag>
  </div>
</template>
<script>
import utils from "../../../../../../utils/utils.js";
import ConfigurationReservedInstanceTag from "../ConfigurationReservedInstanceTag.vue";

var tableElasticComputeCloudResourceVue = {};
export default {
  name: "TableElasticComputeCloudResource",
  components: {
    ConfigurationReservedInstanceTag
  },
  data() {
    return {
      tableHeight: 0,
      modalLoading: false,
      isShowReservedInstanceTag: false,
      columns: [
        {
          title: this.$t("RAM.AWS.RI.EC2.accountID"),
          fixed: "left",
          minWidth: 120,
          key: "awsId"
        },
        {
          title: this.$t("RAM.AWS.RI.EC2.accountName"),
          minWidth: 150,
          key: "awsName"
        },
        {
          title: this.$t("RAM.AWS.RI.EC2.region"),
          minWidth: 150,
          key: "region"
        },
        {
          title: "tag",
          minWidth: 150,
          key: "tag"
        },
        {
          title: this.$t("RAM.AWS.RI.EC2.instanceType"),
          minWidth: 150,
          key: "instanceType"
        },
        {
          title: this.$t("RAM.AWS.RI.EC2.start"),
          minWidth: 150,
          key: "start",
          sortable: true
        },
        {
          title: this.$t("RAM.AWS.RI.EC2.overdue"),
          minWidth: 150,
          key: "end",
          sortable: true
        },
        {
          title: this.$t("RAM.AWS.RI.EC2.due"),
          minWidth: 150,
          key: "duration"
        },
        {
          title: this.$t("RAM.AWS.RI.EC2.paymentMethod"),
          minWidth: 150,
          key: "offeringType"
        },
        {
          title: this.$t("RAM.AWS.RI.EC2.providedType"),
          minWidth: 150,
          key: "offeringClass"
        },
        {
          title: this.$t("RAM.AWS.RI.EC2.platform"),
          minWidth: 150,
          key: "productDescription"
        },
        {
          title: this.$t("RAM.AWS.RI.EC2.status"),
          minWidth: 150,
          key: "state"
        },
        {
          title: this.$t("RAM.AWS.RI.EC2.rentTime"),
          minWidth: 150,
          key: "instanceTenancy"
        },
        {
          title: this.$t("RAM.AWS.RI.EC2.instanceAmount"),
          minWidth: 150,
          key: "instanceCount"
        },
        {
          title: this.$t("RAM.AWS.RI.EC2.standardizeFactor"),
          minWidth: 150,
          key: "matchingResult"
        },
        {
          title: this.$t("common.operation"),
          minWidth: 150,
          fixed: "right",
          slot: "operation"
        }
      ],
      reservedInstanceList: [],
      reservedInstanceListData: []
    };
  },
  beforeCreate: function() {
    tableElasticComputeCloudResourceVue = this;
  },
  mounted() {
    window.addEventListener("resize", this.getTableHeight);
    this.getTableHeight();
  },
  methods: {
    getTableHeight() {
      this.tableHeight = window.innerHeight - 210;
    },
    // 显示数据
    getReservedInstances: function(reservedInstanceDTO) {
      tableElasticComputeCloudResourceVue.reservedInstanceDTO = reservedInstanceDTO;
      // 转圈圈
      tableElasticComputeCloudResourceVue.modalLoading = true;
      // 清空数据
      tableElasticComputeCloudResourceVue.reservedInstanceList = [];
      tableElasticComputeCloudResourceVue.$api.reservedInstance
        .getReservedInstances(reservedInstanceDTO)
        .then(res => {
          tableElasticComputeCloudResourceVue.modalLoading = false;
          if (res == null || res.data == null) {
            return;
          }
          let reservedInstances = res.data;
          for (let i = 0; i < reservedInstances.length; i++) {
            reservedInstances[i].start = utils.methods.formatDate(
              reservedInstances[i].start
            );
            reservedInstances[i].end = utils.methods.formatDate(
              reservedInstances[i].end
            );
            reservedInstances[i].duration =
              reservedInstances[i].duration === 31536000
                ? tableElasticComputeCloudResourceVue.$t(
                    "RAM.AWS.reservedInstanceTag.oneYear"
                  )
                : tableElasticComputeCloudResourceVue.$t(
                    "RAM.AWS.reservedInstanceTag.threeYears"
                  );
          }
          tableElasticComputeCloudResourceVue.reservedInstanceListData = JSON.parse(
            JSON.stringify(reservedInstances)
          );
          tableElasticComputeCloudResourceVue.reservedInstanceList = reservedInstances;
        });
    },
    configTag: function(row) {
      this.isShowReservedInstanceTag = true;
      this.$nextTick(function() {
        this.$refs.configurationReservedInstanceTag.getConfigurationReservedInstanceTagList(
          row,
          0
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/reserved_instance/ec2/TableElasticComputeCloudResource.vue